export const FETCH_INSCRIPTIONS = 'FETCH_INSCRIPTIONS'
export const SET_INSCRIPTIONS = 'SET_INSCRIPTIONS'
export const UPDATE_INSCRIPTIONS = 'UPDATE_INSCRIPTIONS'
// export const MASS_UPDATE_INSCRIPTIONS = 'MASS_UPDATE_INSCRIPTIONS'
